import { theme } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { DeletedFilled } from 'assets/images/svg';
import { devicesActions } from 'reduxStore/devices/slice';
import { selectDevicesByDeviceID } from 'reduxStore/devices/selectors';
import { selectSites } from 'reduxStore/sites/selectors';
import { Button, Divider, Flex, Modal, Space, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const RemoveSiteDeviceModal = ({ deviceID, siteIDs, visible, setVisible }) => {
	const {
		token: { fontSizeSM, paddingLG, paddingSM, paddingXL, paddingXS, marginXL, marginXS }
	} = theme.useToken();
	const dispatch = useDispatch();

	const sites = useSelector(selectSites);
	const device = useSelector((state) => selectDevicesByDeviceID(state, deviceID));

	const currentSiteIDs = device?.sites?.map((s) => s.siteID) || [];
	const removedNames = sites
		.filter((s) => siteIDs?.includes(s.siteID))
		.map((s) => s.name)
		.join(', ');

	const handleCancel = () => setVisible(false);

	const handleConfirm = () => {
		const newSiteIDs = currentSiteIDs.filter((id) => !siteIDs.includes(id));
		dispatch(devicesActions.updateDeviceSites({ deviceID, siteIDs: newSiteIDs }));
		setVisible(false);
	};

	return (
		<Modal
			open={visible}
			onCancel={handleCancel}
			closeIcon={false}
			centered
			destroyOnClose
			footer={[
				<Flex
					align='center'
					justify='center'
					style={{ marginTop: marginXL, padding: `0px ${paddingXS}px` }}
					gap={12}
					key='footer'
				>
					<Button onClick={handleCancel} type='default' block>
						Cancel
					</Button>
					<Button onClick={handleConfirm} type='primary' danger block>
						Remove
					</Button>
				</Flex>
			]}
			width={350}
			styles={{ content: { padding: paddingXL } }}
		>
			<Flex vertical align='center' justify='center' gap={paddingSM}>
				<DeletedFilled />
				<Flex vertical gap={paddingLG}>
					<Space
						size={paddingXS}
						direction='vertical'
						align='center'
						style={{ margin: `${paddingXS}px 0px` }}
					>
						<Title
							level={5}
							style={{
								margin: 0,
								lineHeight: '24px',
								textAlign: 'center',
								padding: `0px ${paddingXL}px`
							}}
						>
							Remove site assignment?
						</Title>
						<Text
							style={{
								fontSize: fontSizeSM,
								lineHeight: '24px',
								textAlign: 'center',
								display: 'block'
							}}
						>
							This will also delete the device's location
							<br />
							from the floorplan if it has one.
							<br />
							This cannot be undone.
						</Text>
					</Space>

					<Flex vertical gap={marginXS}>
						<Divider orientation='center' plain style={{ margin: 0, padding: 0 }}>
							<Text style={{ fontSize: fontSizeSM, fontWeight: 200 }}>Sites to remove</Text>
						</Divider>
						<Text style={{ fontSize: fontSizeSM, fontWeight: 200, textAlign: 'center' }}>
							{removedNames}
						</Text>
					</Flex>
				</Flex>
			</Flex>
		</Modal>
	);
};

export default RemoveSiteDeviceModal;
